import React from 'react';
import { IconBase } from '../Base';
export const IconBHD = (props) => (React.createElement(IconBase, { ...props, viewportSize: 24 },
    React.createElement("g", { clipPath: "url(#clip0_2_7447)" },
        React.createElement("path", { d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z", fill: "#F0F0F0" }),
        React.createElement("path", { d: "M12 0C9.592 0 7.35.71 5.47 1.931L8.557 4 4.696 6l3.86 2-3.86 2 3.86 2-3.86 2 3.86 2-3.86 2 3.86 2-3.086 2.069A11.942 11.942 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z", fill: "#D80027" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_2_7447" },
            React.createElement("path", { fill: "#fff", d: "M0 0H24V24H0z" })))));
//# sourceMappingURL=BHD.js.map